var ResourcesBySupplementsService = /** @class */ (function () {
    /*@ngInject*/
    function ResourcesBySupplementsService($http) {
        this.$http = $http;
    }
    ResourcesBySupplementsService.prototype.getNutritionalContent = function () {
        var reqData = "/assets/a-z-index/a-to-z-index-of-vitamins-and-minerals/~default";
        var request = this.$http({
            method: "get",
            url: "/api/education/clinical-resources-content?Resource=" + reqData
        });
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    ResourcesBySupplementsService.prototype.getBotanicalContent = function () {
        var reqData = "/assets/a-z-index/a-to-z-index-of-herbal-remedies/~default";
        var request = this.$http({
            method: "get",
            url: "/api/education/clinical-resources-content?Resource=" + reqData
        });
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    return ResourcesBySupplementsService;
}());
export default ResourcesBySupplementsService;
//# sourceMappingURL=resources-by-supplements.service.js.map